import React from 'react'
import { TextField } from '@material-ui/core';

export default function Input(props) {

    const { name, label,style, value,error=null,onKeyUp,variant, onChange, ...other } = props;
    return (
        <TextField
            variant={variant}
            label={label}
            name={name}
            value={value}
            style={style}
            onChange={onChange}
            onKeyUp={onKeyUp}
            {...other}
            {...(error && {error:true,helperText:error})}
        />
    )
}
